//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class SpSignatureClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "/api/";
    }

    signature_GetSignaturesList(): Promise<SignatureRequest[]> {
        let url_ = this.baseUrl + "/Signature/listRequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignature_GetSignaturesList(_response);
        });
    }

    protected processSignature_GetSignaturesList(response: Response): Promise<SignatureRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SignatureRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignatureRequest[]>(null as any);
    }

    signature_GetSignatureById(id: string | null): Promise<SignatureRequest> {
        let url_ = this.baseUrl + "/Signature/get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignature_GetSignatureById(_response);
        });
    }

    protected processSignature_GetSignatureById(response: Response): Promise<SignatureRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignatureRequest.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignatureRequest>(null as any);
    }

    signature_ValidateSignature(req: SignatureRequest): Promise<string> {
        let url_ = this.baseUrl + "/Signature/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignature_ValidateSignature(_response);
        });
    }

    protected processSignature_ValidateSignature(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    signature_PostSignatureReq(req: SignatureRequestInput): Promise<string> {
        let url_ = this.baseUrl + "/Signature/addSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(req);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignature_PostSignatureReq(_response);
        });
    }

    protected processSignature_PostSignatureReq(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    signature_getSignatures(listIDReq: string[]): Promise<SignatureRequest[]> {
        let url_ = this.baseUrl + "/Signature/getMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listIDReq);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignature_getSignatures(_response);
        });
    }

    protected processSignature_getSignatures(response: Response): Promise<SignatureRequest[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SignatureRequest.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignatureRequest[]>(null as any);
    }

    signature_VerifySigning(signature: SignatureCheck): Promise<boolean> {
        let url_ = this.baseUrl + "/Signature/verifySigning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signature);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignature_VerifySigning(_response);
        });
    }

    protected processSignature_VerifySigning(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    signature_DeleteSignature(signature: SignatureCheck): Promise<boolean> {
        let url_ = this.baseUrl + "/Signature/DeleteSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(signature);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSignature_DeleteSignature(_response);
        });
    }

    protected processSignature_DeleteSignature(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SignatureContextData implements ISignatureContextData {
    idReq!: string;
    nom!: string;
    ipp!: string;
    prenom!: string;
    numeroTel?: string | undefined;
    pdFile!: string;
    numeroPage!: number;
    signatureImage?: string | undefined;
    reverseAPIURL!: string;
    redirectUrl?: string | undefined;
    signaturePos!: number[];
    updated?: boolean | undefined;
    typeDocument!: string;
    texte?: string | undefined;
    dateLimite?: Date | undefined;
    formulaire?: Formulaire | undefined;
    sexe?: Genre | undefined;

    constructor(data?: ISignatureContextData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.signaturePos = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idReq = _data["idReq"];
            this.nom = _data["nom"];
            this.ipp = _data["ipp"];
            this.prenom = _data["prenom"];
            this.numeroTel = _data["numeroTel"];
            this.pdFile = _data["pdFile"];
            this.numeroPage = _data["numeroPage"];
            this.signatureImage = _data["signatureImage"];
            this.reverseAPIURL = _data["reverseAPIURL"];
            this.redirectUrl = _data["redirectUrl"];
            if (Array.isArray(_data["signaturePos"])) {
                this.signaturePos = [] as any;
                for (let item of _data["signaturePos"])
                    this.signaturePos!.push(item);
            }
            this.updated = _data["updated"];
            this.typeDocument = _data["typeDocument"];
            this.texte = _data["texte"];
            this.dateLimite = _data["dateLimite"] ? new Date(_data["dateLimite"].toString()) : undefined as any;
            this.formulaire = _data["formulaire"] ? Formulaire.fromJS(_data["formulaire"]) : undefined as any;
            this.sexe = _data["sexe"];
        }
    }

    static fromJS(data: any): SignatureContextData {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureContextData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idReq"] = this.idReq;
        data["nom"] = this.nom;
        data["ipp"] = this.ipp;
        data["prenom"] = this.prenom;
        data["numeroTel"] = this.numeroTel;
        data["pdFile"] = this.pdFile;
        data["numeroPage"] = this.numeroPage;
        data["signatureImage"] = this.signatureImage;
        data["reverseAPIURL"] = this.reverseAPIURL;
        data["redirectUrl"] = this.redirectUrl;
        if (Array.isArray(this.signaturePos)) {
            data["signaturePos"] = [];
            for (let item of this.signaturePos)
                data["signaturePos"].push(item);
        }
        data["updated"] = this.updated;
        data["typeDocument"] = this.typeDocument;
        data["texte"] = this.texte;
        data["dateLimite"] = this.dateLimite ? this.dateLimite.toISOString() : undefined as any;
        data["formulaire"] = this.formulaire ? this.formulaire.toJSON() : undefined as any;
        data["sexe"] = this.sexe;
        return data;
    }
}

export interface ISignatureContextData {
    idReq: string;
    nom: string;
    ipp: string;
    prenom: string;
    numeroTel?: string | undefined;
    pdFile: string;
    numeroPage: number;
    signatureImage?: string | undefined;
    reverseAPIURL: string;
    redirectUrl?: string | undefined;
    signaturePos: number[];
    updated?: boolean | undefined;
    typeDocument: string;
    texte?: string | undefined;
    dateLimite?: Date | undefined;
    formulaire?: Formulaire | undefined;
    sexe?: Genre | undefined;
}

export class SignatureRequest extends SignatureContextData implements ISignatureRequest {
    id?: string;
    signatureDate?: Date | undefined;
    createdAt?: Date;
    formulaireDataResult?: { [key: string]: string[]; };

    constructor(data?: ISignatureRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.signatureDate = _data["signatureDate"] ? new Date(_data["signatureDate"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            if (_data["formulaireDataResult"]) {
                this.formulaireDataResult = {} as any;
                for (let key in _data["formulaireDataResult"]) {
                    if (_data["formulaireDataResult"].hasOwnProperty(key))
                        (this.formulaireDataResult as any)![key] = _data["formulaireDataResult"][key] !== undefined ? _data["formulaireDataResult"][key] : [];
                }
            }
        }
    }

    static override fromJS(data: any): SignatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signatureDate"] = this.signatureDate ? this.signatureDate.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        if (this.formulaireDataResult) {
            data["formulaireDataResult"] = {};
            for (let key in this.formulaireDataResult) {
                if (this.formulaireDataResult.hasOwnProperty(key))
                    (data["formulaireDataResult"] as any)[key] = (this.formulaireDataResult as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISignatureRequest extends ISignatureContextData {
    id?: string;
    signatureDate?: Date | undefined;
    createdAt?: Date;
    formulaireDataResult?: { [key: string]: string[]; };
}

export class Formulaire implements IFormulaire {
    inputs?: Input[];

    constructor(data?: IFormulaire) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inputs"])) {
                this.inputs = [] as any;
                for (let item of _data["inputs"])
                    this.inputs!.push(Input.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Formulaire {
        data = typeof data === 'object' ? data : {};
        let result = new Formulaire();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inputs)) {
            data["inputs"] = [];
            for (let item of this.inputs)
                data["inputs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormulaire {
    inputs?: Input[];
}

export class Input implements IInput {
    libelle?: string;
    nomInterne?: string;
    keyValues?: KeyValue[] | undefined;
    inputType?: InputType | undefined;
    obligatoire?: boolean;
    multiSelection?: boolean;

    constructor(data?: IInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.libelle = _data["libelle"];
            this.nomInterne = _data["nomInterne"];
            if (Array.isArray(_data["keyValues"])) {
                this.keyValues = [] as any;
                for (let item of _data["keyValues"])
                    this.keyValues!.push(KeyValue.fromJS(item));
            }
            this.inputType = _data["inputType"];
            this.obligatoire = _data["obligatoire"];
            this.multiSelection = _data["multiSelection"];
        }
    }

    static fromJS(data: any): Input {
        data = typeof data === 'object' ? data : {};
        let result = new Input();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["libelle"] = this.libelle;
        data["nomInterne"] = this.nomInterne;
        if (Array.isArray(this.keyValues)) {
            data["keyValues"] = [];
            for (let item of this.keyValues)
                data["keyValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["inputType"] = this.inputType;
        data["obligatoire"] = this.obligatoire;
        data["multiSelection"] = this.multiSelection;
        return data;
    }
}

export interface IInput {
    libelle?: string;
    nomInterne?: string;
    keyValues?: KeyValue[] | undefined;
    inputType?: InputType | undefined;
    obligatoire?: boolean;
    multiSelection?: boolean;
}

export class KeyValue implements IKeyValue {
    key?: string;
    value?: string;
    callbackUrl?: string | undefined;

    constructor(data?: IKeyValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.callbackUrl = _data["callbackUrl"];
        }
    }

    static fromJS(data: any): KeyValue {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["callbackUrl"] = this.callbackUrl;
        return data;
    }
}

export interface IKeyValue {
    key?: string;
    value?: string;
    callbackUrl?: string | undefined;
}

export enum InputType {
    Textbox = 0,
    Checkbox = 1,
    Radio = 2,
    Select = 3,
}

export enum Genre {
    Homme = 1,
    Femme = 2,
}

export class SignatureRequestInput extends SignatureContextData implements ISignatureRequestInput {
    formulaireDataResult?: KeyValuePairOfStringAndListOfString[] | undefined;

    constructor(data?: ISignatureRequestInput) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["formulaireDataResult"])) {
                this.formulaireDataResult = [] as any;
                for (let item of _data["formulaireDataResult"])
                    this.formulaireDataResult!.push(KeyValuePairOfStringAndListOfString.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): SignatureRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureRequestInput();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.formulaireDataResult)) {
            data["formulaireDataResult"] = [];
            for (let item of this.formulaireDataResult)
                data["formulaireDataResult"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISignatureRequestInput extends ISignatureContextData {
    formulaireDataResult?: KeyValuePairOfStringAndListOfString[] | undefined;
}

export class KeyValuePairOfStringAndListOfString implements IKeyValuePairOfStringAndListOfString {
    key?: string;
    value?: string[];

    constructor(data?: IKeyValuePairOfStringAndListOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(item);
            }
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndListOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item);
        }
        return data;
    }
}

export interface IKeyValuePairOfStringAndListOfString {
    key?: string;
    value?: string[];
}

export class SignatureCheck implements ISignatureCheck {
    idDevis?: string;

    constructor(data?: ISignatureCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idDevis = _data["idDevis"];
        }
    }

    static fromJS(data: any): SignatureCheck {
        data = typeof data === 'object' ? data : {};
        let result = new SignatureCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idDevis"] = this.idDevis;
        return data;
    }
}

export interface ISignatureCheck {
    idDevis?: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}